import React, { useState, useEffect } from "react";
import FloatingButton from "./components/FloatingButton";
import LiveAssistance from "./components/LiveAssistance";
import CallbackForm from "./components/Callback";
import CallUs from "./components/CallUs"
import SendEmail from "./components/SendEmail"
import "tailwindcss/tailwind.css";

const App = () => {
  const [isHovering, setIsHovering] = useState(false);
  const [isLiveAssistanceOpen, setIsLiveAssistanceOpen] = useState(false);
  const [isCallbackFormOpen, setIsCallbackFormOpen] = useState(false);
  const [isCallUsFormOpen, setIsCallUsFormOpen] = useState(false);
  const [isSendEmailFormOpen, setIsSendEmailFormOpen] = useState(false);

  // Set up Genesys event listeners once on mount
  useEffect(() => {
    const Genesys = window.Genesys;

    if (!Genesys) {
      console.warn("Genesys is not available yet.");
      return;
    }

    Genesys("subscribe", "Messenger.ready", (e: any) => {
      console.log("Genesys Messenger is ready:", e);
    });

    Genesys("subscribe", "Messenger.opened", (e: any) => {
      console.log("Messenger opened:", e);
    });

    Genesys("subscribe", "Messenger.closed", (e: any) => {
      console.log("Messenger closed:", e);
    });
  }, []); // Empty dependency array: only run once on mount

  const handleLiveAssistanceOpen = () => {
    setIsLiveAssistanceOpen(true);
    setIsCallbackFormOpen(false);
    setIsCallUsFormOpen(false);
    setIsSendEmailFormOpen(false);
  };

  const handleCallUsFormOpen = () => {
    setIsLiveAssistanceOpen(false);
    setIsCallUsFormOpen(true);
    setIsCallbackFormOpen(false);
    setIsSendEmailFormOpen(false);
  };

  const handleCallUsFormClose = () => {
    setIsLiveAssistanceOpen(true);
    setIsCallUsFormOpen(false);
    setIsCallbackFormOpen(false);
    setIsSendEmailFormOpen(false);
  };

  const handleSendEmailFormOpen = () => {
    setIsLiveAssistanceOpen(false);
    setIsSendEmailFormOpen(true);
    setIsCallbackFormOpen(false);
    setIsCallUsFormOpen(false);
  };

  const handleSendEmailFormClose = () => {
    setIsLiveAssistanceOpen(true);
    setIsSendEmailFormOpen(false);
    setIsCallbackFormOpen(false);
    setIsCallUsFormOpen(false);
  };

  const handleLiveAssistanceClose = () => {
    setIsLiveAssistanceOpen(false);
  };

  const handleCallbackFormOpen = () => {
    setIsCallbackFormOpen(true);
    setIsLiveAssistanceOpen(false);
    setIsCallUsFormOpen(false);
    setIsSendEmailFormOpen(false);
  };

  const handleCallbackFormClose = () => {
    setIsCallbackFormOpen(false);
    handleLiveAssistanceOpen();
    setIsCallUsFormOpen(false);
    setIsSendEmailFormOpen(false);
  };

  const handleSuccessCallbackFormClose = () => {
    setIsCallbackFormOpen(false);
  };

  const handleSuccessSendEmailFormClose = () => {
    setIsSendEmailFormOpen(false);
  };

  const handleLiveChatClick = () => {
    if (window.Genesys) {
      window.Genesys("command", "Messenger.open");
      setIsLiveAssistanceOpen(false); // 👈 close the modal
    } else {
      console.error("Genesys Messenger is not loaded.");
    }
  };

  return (
    <div
      className="app-container"
      style={{ position: "relative", zIndex: 9999 }}
    >
      <FloatingButton
        onHover={() => setIsHovering(true)}
        onHoverOut={() => setIsHovering(false)}
        onClick={handleLiveAssistanceOpen}
        icon={"live_assistance.png"}
        label="Live Assistance"
        isHovering={isHovering}
      />
      {isLiveAssistanceOpen && (
        <LiveAssistance
          onClose={handleLiveAssistanceClose}
          onCallbackClick={handleCallbackFormOpen}
          onLiveChatClick={handleLiveChatClick}
          onCallUsClick={handleCallUsFormOpen}
          onSendEmailClick={handleSendEmailFormOpen}
        />
      )}
      {isCallbackFormOpen && (
        <CallbackForm
          onClose={handleCallbackFormClose}
          onSuccessClose={handleSuccessCallbackFormClose}
        />
      )}
      {isCallUsFormOpen && (
        <CallUs
          onClose={handleCallUsFormClose}
        />
      )}
      {isSendEmailFormOpen && (
        <SendEmail
          onClose={handleSendEmailFormClose}
          onSuccessClose={handleSuccessSendEmailFormClose}
        />
      )}
    </div>
  );
};

export default App;
